/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core"
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ArrowUp, Bug, Edit, Feedback, Mail, Request, Twitter } from "./icons/Icons";

const FeedbackButton = () => {
  const [isActive, setActive] = useState(false);

  useEffect(() => {
    document.addEventListener('click', togglePopup);

    return () => document.removeEventListener('click', togglePopup);
  }, []);

  const togglePopup = (e) => {
    if (!e.target.closest('#feedbackPopup')) {
      setActive(false);
    }
  }

  return (
    <div className="headerSidePopup" id="feedbackPopup">
            <button className={`feedback bg-black/5 dark:bg-black/50 opacity-50 text-black dark:text-white ${isActive ? 'active' : ''}`} onClick={e => setActive(isActive => !isActive)}>
              <Feedback />
              feedback 
              <i className="arrow"> <ArrowUp /></i>
            </button>
            <div className={`feedbackSlide ${isActive ? 'show' : 'hide'}`}  style={{ background: "linear-gradient(0deg, rgba(41, 44, 54, 0.05), rgba(41, 44, 54, 0.05)), var(--theme-mode-color-white)" }}>
              <div className="feedbackSlide-header">
                <h3 className="feedbackTitle text-[var(--accent-color)] dark:text-white"><span css={{
                  color: `var(--accent-color) !important`,
                }}>Help shape LifeTab into the app you want it to be!</span> Requests, ideas, thoughts, feedback — anything! Let us know. </h3>
                <div className="feedbackAction">
                  <ul className="actionbtn-ul">
                    <li className="actionbtn-li"><a style={{background: 'linear-gradient(0deg, rgba(41, 44, 54, 0.1), rgba(41, 44, 54, 0.1)), var(--theme-mode-color-white)'}} href="https://tally.so/r/mJ1ZAr" className="feedbackActionBtn text-[var(--accent-color)] dark:!text-white opacity-100 dark:!opacity-50"><Request /> Feature Request</a></li>
                    <li className="actionbtn-li"><a style={{background: 'linear-gradient(0deg, rgba(41, 44, 54, 0.1), rgba(41, 44, 54, 0.1)), var(--theme-mode-color-white)'}} href="https://tally.so/r/waOgl2" className="feedbackActionBtn text-[var(--accent-color)] dark:!text-white opacity-100 dark:!opacity-50"><Bug /> Bug Report</a></li>
                    <li className="actionbtn-li"><a style={{background: 'linear-gradient(0deg, rgba(41, 44, 54, 0.1), rgba(41, 44, 54, 0.1)), var(--theme-mode-color-white)'}} href="https://tally.so/r/mOQezY" className="feedbackActionBtn text-[var(--accent-color)] dark:!text-white opacity-100 dark:!opacity-50"><Edit /> General Feedback</a></li>
                  </ul>
                </div>
                <div className="reachOut">
                  <p className="reachOut-text text-[var(--accent-color)] dark:text-white">If you would like to reach out to us directly , feel free to send us an email at <span css={{
                  color: `var(--accent-color) !important`,
                }}>hello@lifetab.co</span></p>
                </div>
              </div>
              <div className="feedbackSlide-footer w-full">
                  {/* <div className="community-card" style={{background: theme == 'dark' ? 'linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), #5865F2' : 'linear-gradient(0deg, rgba(41, 44, 54, 0.05), rgba(41, 44, 54, 0.05)), linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #5865F2'}}>
                    <button className="join-Btn"><img src="../images/join-community.svg" /> JOIN THE DISCORD COMMUNITY</button>
                  </div> */}
          <div className="community-card bg-none">
            <a href="https://discord.gg/3gNDHWCTQX" className="join-Btn"><img src="../images/join-community.svg" /> JOIN THE DISCORD COMMUNITY</a>
          </div>
          <div className="followUs flex justify-center items-center flex-col">
            <p className="follow-text text-black/50 dark:text-white/50 flex justify-center items-center">Follow us on <Twitter style={{ marginLeft: '4px' }} /> Twitter to keep up with latest updates</p>
            <a href="https://twitter.com/lifetabapp" css={{
              color: `var(--accent-color) !important`,
            }}>@LifeTab</a>
          </div>
        </div>
      </div>
    </div >
  )
}

export default FeedbackButton